import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import { Typography } from '@material-ui/core';

import CopyToClipboardAction from '../Actions/CopyToClipboardAction';

const CopyToClipboardChip = (props) => {
  const {
    notify, label, clipboardProps, labelProps, ...others
  } = props;

  const content = labelProps ? <Typography {...labelProps}>{label}</Typography> : label;

  return (
    <CopyToClipboardAction notify={notify} text={label} {...clipboardProps}>
      <Chip label={content} clickable {...others} />
    </CopyToClipboardAction>
  );
};

CopyToClipboardChip.defaultProps = {
  notify: true,
  clipboardProps: null
};

CopyToClipboardChip.propTypes = {
  clipboardProps: PropTypes.instanceOf(Object),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired,
  notify: PropTypes.bool,
  labelProps: PropTypes.instanceOf(Object)
};

export default CopyToClipboardChip;
